module.exports = __webpack_public_path__ + "img/north.f8b1e2bc.png";